// This icon file is generated automatically.
var PageOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M171 32.02H29a12.08 12.08 0 00-12.06 12.06v111.84c0 6.65 5.41 12.07 12.06 12.07h142c6.65 0 12.06-5.42 12.06-12.07V44.08c0-6.65-5.41-12.06-12.06-12.06zM80.55 50.44a5.45 5.45 0 11-10.9 0 5.45 5.45 0 0110.9 0zm-18.4 0a5.45 5.45 0 11-10.9 0 5.45 5.45 0 0110.9 0zm-18.39 0a5.45 5.45 0 11-10.9 0 5.45 5.45 0 0110.9 0zM171 161.85H29a5.94 5.94 0 01-5.93-5.93v-89.3h153.86v89.3a5.94 5.94 0 01-5.93 5.94zm-19.61-69.7h-65.4a3.07 3.07 0 000 6.14h65.4a3.07 3.07 0 000-6.13zm0 33.17H51.94a3.07 3.07 0 000 6.13h99.45a3.07 3.07 0 000-6.13z" } }] }, "name": "page", "theme": "outlined" };
export default PageOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PageOutlined.js
// module id = 3744
// module chunks = 0